import { Popover } from "antd"
import { AssigneesSelect } from "../../../assignees/assignees-select"
import { useEffect, useState } from "react"
import OutsideAlerter from "components/view-utils/outside-alerter"
import { SidebarButton } from "../sidebar-button"
import { useFormikContext } from "formik"
import { TApiTaskAssignee } from "@timenotes/shared/src/services/api-client/types"
import styled from "styled-components"
import { TaskFormObject } from "@timenotes/shared/src/services/tasks/hooks/use-task-formik"
import { InfoIcon } from "components/base/info-icon"

interface Props extends React.PropsWithChildren {}

export const TaskAssigneesSelectPopover = (props: Props) => {
  const [visible, setVisible] = useState(false)

  const formik = useFormikContext<TaskFormObject>()
  const task = formik.values

  // Submit form on popover close to not do it on every single change of the big users and groups list
  // only on hiding the popover and if the field changed
  useEffect(() => {
    if (visible == false && JSON.stringify(formik.initialValues.assignees?.map((a) => a.id)) != JSON.stringify(formik.values.assignees?.map((a) => a.id))) {
      formik.submitForm()
    }
  }, [visible])

  return (
    <>
      <OutsideAlerter
        onClick={() => setVisible(false)}
      >
        <Popover
          getPopupContainer={(triggerNode) => triggerNode}
          content={(
            <>
              <AssigneesSelect 
                filters={{
                  projectId: task.project?.id,
                }}
                value={task.assignees}
                onChange={(value) => {
                  formik.setFieldValue('assignees', value)
                }}

                onKeyDown={(e) => {
                  if (e.key == 'Escape') {
                    setVisible(false)
                  }
                }}
              />
            </>
          )}
          destroyTooltipOnHide={true}
          placement="bottom"
          trigger={[]}
          visible={visible}
        >
          <div onClick={() => setVisible((v) => (!v))}>
            {props.children || <DefaultTarget assignees={task.assignees} />}
          </div>
        </Popover>
      </OutsideAlerter>

      <div
        style={{
          paddingTop: '5px',
          paddingBottom: '5px',
          marginLeft: '8px',
          cursor: 'pointer',
          maxHeight: '190px',
          overflow: 'scroll',
        }}
        onClick={() => setVisible(true)}
      >
        { task.assignees?.length == 0 ? (
          <> No assignees </>
        ) : (
          <>
            {task.assignees?.map((assignee) => (
              <AssigneeAvatar assignee={assignee} />
            ))}
          </>
        )}
      </div>
    </>
  )
}

const DefaultTarget = () => (
  <SidebarButton>
    Assignees <InfoIcon text="When a task is assigned to the member or the group, only those selected members can log the time into it. Otherwise, anyone can log the time."/>
  </SidebarButton>
)

export const UserCircle = styled.div`
  width: 24px;
  height: 24px;
  display: flex;
  align-items: center;
  justify-content: center;
  border-radius: 50%;
  background: #d8c1f4;
  cursor: pointer;
  font-family: "Roboto";
  font-style: normal;
  font-weight: 400;
  font-size: 11px;
  line-height: 20px;
  color: #8f3ef7;
  margin: 0 2px 0 0;
  overflow: hidden;
`

interface AssigneeAvatarProps {
  assignee: TApiTaskAssignee
}

const AssigneeAvatar = (props: AssigneeAvatarProps) => {
  return (
    <div
      style={{
        display: 'flex',
        gap: '10px',
        marginBottom: '5px',
      }}
    >
      <UserCircle>
        {getAssigneeInitials(props.assignee)}
      </UserCircle>
      {props.assignee.name}
    </div>
  )
}

const getAssigneeInitials = (assignee: TApiTaskAssignee) => {
  const { type, name } = assignee

  return (
    <>
      {type === "UsersAccount" &&
        (name.split(" ").length > 1
          ? `${name.toUpperCase().split(" ")[1][0]}${
              name.toUpperCase().split(" ")[0][0]
            }`
          : `${name[0].toUpperCase()}${name[1].toUpperCase()}`)}
      {type === "MembersGroup" &&
        `${name[0].toUpperCase()}${name[1].toUpperCase()}`}
    </>
  )
}
